import { Controller } from '@hotwired/stimulus'

// Makes a whole table row open its link. Only the row's first cell holds a
// real anchor — one tab stop per row instead of one per cell — so a click
// anywhere else in the row is forwarded to it. Clicks that already landed on
// an interactive element are left alone.
export default class extends Controller {
  static targets = ['link']

  open(event) {
    if (event.target.closest('a, button, input, label, select, textarea')) return
    if (window.getSelection()?.toString()) return

    this.linkTarget.click()
  }
}
